<template>
  <div>
    <dyhBasetable :who="'allvip'" :column="underinfoColumn" ref="dyhBaseTableRef" @reflashTable="OfflineGetBaseInfoList"
      :bs_place="'请输入会员名，会员卡号查询'"></dyhBasetable>
  </div>
</template>
<script>
import dyhBasetable from "./components/dyh-basetable.vue";
import { offlineGetBaseInfoList } from "@/api/offlinestores.js";
export default {
  name: "allvip",
  data() {
    return {
      tableData: [],
      //线下店铺信息表格的列
      underinfoColumn: [
        /* {
          field: "",
          key: "b",
          title: "",
          type: "checkbox",
          width: 50,
          align: "center",
          fixed: "left"
        }, */
        {
          field: "index",
          key: "a",
          title: "行号",
          width: 60,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.rowKey + 1;
          }
        },
        {
          field: "card_id",
          key: "card_id",
          title: "卡号",
          align: "center",
          width: 100,
          fixed: "left"
        },
        {
          field: "name",
          key: "name",
          title: "用户名",
          align: "center",
          width: 150,
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "integral",
          key: "integral",
          title: "积分",
          align: "center",
          width: 150,
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "balance",
          key: "balance",
          title: "余额",
          align: "center",
          width: 100
        },
        {
          field: "grade",
          key: "grade",
          title: "卡类型",
          align: "center",
          width: 100
        },
        {
          field: "status",
          key: "status",
          title: "状态",
          align: "center",
          width: 100
        }
        /* {
          field: "",
          key: "e",
          title: "管理",
          width: 200,
          center: "left",
          fixed: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <button
                  class="underinfo-button-err"
                  on-click={() => this.deleteRow(rowIndex)}
                >
                  审核
                </button>
              </span>
            );
          }
        } */
      ]
    };
  },
  mounted() {
    this.OfflineGetBaseInfoList();
  },
  components: { dyhBasetable },
  methods: {
    async OfflineGetBaseInfoList() {
      const list = await offlineGetBaseInfoList();

      //eslint-disable-next-line eqeqeq
      if (list == [] || list.length === 0) {
        this.warnMessage("未找到店铺的会员信息！");
        this.$refs.dyhBaseTableRef.getShopList([]);
        return;
      }
      this.tableData = list;
      let data = [];
      for (let i = 0; i < this.tableData.length; i++) {
        data.push({
          rowKey: i,
          ...this.tableData[i]
        })
      }
      this.$refs.dyhBaseTableRef.getShopList(data);
    },
    deleteRow() {
      console.log("删除")
    }
  }
};
</script>
<style lang="less" scoped></style>
